import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ModalPayload,
  ModalStateInterface,
  UpdateModalPayload
} from "./interfaces";

export const initialState: ModalStateInterface = {
  modalType: null,
  modalProps: {},
  isModalOpened: false,
  closeKey: ""
};

export const mainSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    showModal: (state, action: PayloadAction<ModalPayload>) => {
      const { modalType, modalProps, closeKey } = action.payload;
      state.modalType = modalType;
      state.modalProps = modalProps;
      state.closeKey = closeKey;
      state.isModalOpened = true;
    },
    updateModal: (state, action: PayloadAction<UpdateModalPayload>) => {
      state.modalProps = { ...state.modalProps, ...action.payload.modalProps };
    },

    hideModal: (state, action: PayloadAction<string>) => {
      if (state.closeKey && action.payload !== state.closeKey) return;

      if (state.closeKey) state.closeKey = "";

      state.modalType = initialState.modalType;
      state.modalProps = initialState.modalProps;
      state.isModalOpened = false;
    }
  }
});

export const { actions, reducer } = mainSlice;
